export class ShiftTypeModel {
    id: number;
    name: string | '';

    constructor () {
        this.id = 0;
        this.name = '';
    }

    public static fromJson (json: any): ShiftTypeModel {
        const shiftType = new ShiftTypeModel;
        Object.assign(shiftType,{
            id: json.id,
            name: json.name
        })
        return shiftType;
    }
}